import CommunitySearchResultView from 'component/quick_search/view/community_search_result'
import template from 'component/quick_search/template/registration_community_search_result.tmpl'

const RegistrationCommunitySearchResult = CommunitySearchResultView.extend({
    template,
})

export default RegistrationCommunitySearchResult
